module.exports = __webpack_public_path__ + "images/0edd9e8375e5ada487c4973e187232ae-UTAH_LIFE_ELEVATED_orange.jpg";